import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Shared } from '../services/shared';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from '../services/api';
import { Location } from '@angular/common';

@Component({
  selector: 'app-feedback',
  standalone: false,
  templateUrl: './feedback.html',
  styleUrl: './feedback.scss'
})
export class Feedback {
  feedbackForm!: FormGroup;
  phoneNumber!: string;
  sessionId!: string;
  hasPreviousPage = false;


  selectedRating = 0;
  ratingText = [
    '',
    'Poor',
    'Fair',
    'Good',
    'Very Good',
    'Excellent'
  ];
  constructor(private fb: FormBuilder, private sharedService: Shared, private router: Router, private apiservices: Api, private route: ActivatedRoute, private location: Location) { }

  ngOnInit(): void {
    this.feedbackForm = this.fb.group({
      rating: ['', Validators.required],
      remarks: ['']
    });

    this.route.queryParams.subscribe(params => {
      this.phoneNumber = params['phoneNumber'];
      this.sessionId = params['sessionId'];
      this.hasPreviousPage = params['fromParent'] === 'true';

      if (params['rating']) {
        const rating = Number(params['rating']);
        this.selectedRating = rating;
        this.feedbackForm.patchValue({ rating });
      }
    });
  }

  setRating(rating: number) {

    this.selectedRating = rating;

    this.feedbackForm.patchValue({
      rating: rating
    });

  }
  feebackClose(): void {
    if (this.hasPreviousPage) {
      this.location.back();
    } else {
      window.location.replace('https://training.kaboodle.in/home');
    }
  }
  submitFeedback() {
    if (!this.feedbackForm.value.rating) {
      this.apiservices.displayToast('Please select a rating before submitting.', 500);
      return;
    }

    this.apiservices.updateSessionFeedback(
      this.phoneNumber,
      this.sessionId,
      this.feedbackForm.value.rating,
      this.feedbackForm.value.remarks
    ).subscribe({
      next: () => {
        this.feebackClose()
        this.apiservices.displayToast('Thanks for your feedback! We really appreciate it 😊', 200);
      },
      error: (err) => {
        console.error('Error submitting feedback', err);
      }
    });
  }
}
